/** Redirección SSO embebido — nunca enviar el iframe al dashboard del shell (/). */
export function embeddedShellSsoRelaunch(dest?: string) {
  const d = dest || sessionStorage.getItem('d28d_food_dest') || '/dashboard'
  const coach = sessionStorage.getItem('d28d_food_coach_tracking') === '1'
  const params = new URLSearchParams()
  params.set('relaunch', '1')
  params.set('dest', d)
  if (coach) params.set('coach', '1')
  // Path canónico /food; /food-plan sigue vivo por compat.
  const base = (typeof window !== 'undefined' && window.location.pathname.startsWith('/food-plan'))
    ? '/food-plan'
    : '/food'
  window.location.replace(`${base}/shell-sso?${params.toString()}`)
}
